import {
  SLIDE_ONE_DRAG_DROP,
  SLIDE_ONE_REMOVE_DROP,
  SLIDE_ONE_SET_AS_NEXT_STEP
} from '../Redux.constants';


export const slideOneDragDrop = (positionID, componentID) => ({
  type: SLIDE_ONE_DRAG_DROP,
  payload: {positionID, componentID},
});

export const slideOneRemoveDrop = (positionID) => ({
  type: SLIDE_ONE_REMOVE_DROP,
  payload: {positionID},
});

export const slideOneSetAsNextStep = (componentID) => ({
  type: SLIDE_ONE_SET_AS_NEXT_STEP,
  payload: {componentID},
});